import { createSelector } from 'reselect';

const selectGlobalIndustryCodes = (state: any) => state.globalIndustryCodes;


export const selectGlobalIndustryCodesCurrentItem = createSelector([selectGlobalIndustryCodes], (globalIndustryCodes) => globalIndustryCodes.current);

export const selectGlobalIndustryCodesListItems = createSelector([selectGlobalIndustryCodes], (globalIndustryCodes) => globalIndustryCodes.list);

export const selectGlobalIndustryCodesItemById = (itemId: any) =>
    createSelector(selectGlobalIndustryCodesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalIndustryCodesQueryItems = createSelector([selectGlobalIndustryCodes], (globalIndustryCodes) => globalIndustryCodes.query);

export const selectGlobalIndustryCodesCreatedItem = createSelector([selectGlobalIndustryCodes], (globalIndustryCodes) => globalIndustryCodes.create);

export const selectGlobalIndustryCodesUpdatedItem = createSelector([selectGlobalIndustryCodes], (globalIndustryCodes) => globalIndustryCodes.update);

export const selectGlobalIndustryCodesReadItem = createSelector([selectGlobalIndustryCodes], (globalIndustryCodes) => globalIndustryCodes.read);

export const selectGlobalIndustryCodesDeletedItem = createSelector([selectGlobalIndustryCodes], (globalIndustryCodes) => globalIndustryCodes.delete);

export const selectGlobalIndustryCodesSearchedItems = createSelector([selectGlobalIndustryCodes], (globalIndustryCodes) => globalIndustryCodes.search);

export const selectGlobalIndustryCodesItemsCount = createSelector([selectGlobalIndustryCodes], (globalIndustryCodes) => globalIndustryCodes.count);

export const selectGlobalIndustryCodesItemsFilter = createSelector([selectGlobalIndustryCodes], (globalIndustryCodes) => globalIndustryCodes.filter);